class HeroIconsTooltip {
  constructor() {
    this.iconSelectors = [
      '.hero__icon.hero__globe',
      '.hero__icon.hero__building',
      '.hero__icon.hero__advertisement',
      '.hero__icon.hero__health',
      '.hero__icon.hero__relax',
      '.hero__icon.hero__sewing',
      '.hero__icon.hero__cleaning',
    ];

    this.translations = {
      ru: {
        hero__globe: 'Логистика',
        hero__building: 'Строительство',
        hero__advertisement: 'Рекламные услуги',
        hero__health: 'Медицинский центр «Мир здоровья»',
        hero__relax: 'Отдых и развлечения',
        hero__sewing: 'Швейный участок',
        hero__cleaning: 'Клининг',
      },
      en: {
        hero__globe: 'Logistics',
        hero__building: 'Construction',
        hero__advertisement: 'Advertising services',
        hero__health: 'Medical center',
        hero__relax: 'Leisure & Entertainment',
        hero__sewing: 'Sewing services',
        hero__cleaning: 'Cleaning services',
      },
      be: {
        hero__globe: 'Лагістыка',
        hero__building: 'Будаўніцтва',
        hero__advertisement: 'Рэкламныя паслугі',
        hero__health: 'Медыцынскі цэнтр',
        hero__relax: 'Адпачынак і забавы',
        hero__sewing: 'Швейныя паслугі',
        hero__cleaning: 'Клінінг',
      },
    };

    this.currentLang = this.getCurrentLanguage();
    this.tooltipTexts = this.translations[this.currentLang] || this.translations.ru;

    this.tooltipElement = null;
    this.outlineElement = null;
    this.activeIcon = null;
    this.iconResizeObserver = null;

    this.init();
  }

  getCurrentLanguage() {
    if (typeof document === 'undefined') return 'ru';
    const body = document.body;
    const lang = body?.getAttribute('data-lang') || 'ru';
    return ['ru', 'en', 'be'].includes(lang) ? lang : 'ru';
  }

  init() {
    if (typeof document === 'undefined') return;

    // this.initDelayedFadeInForHeroIcons();
    this.initIconsResponsivePosition();

    const icons = this.iconSelectors
      .map((selector) => Array.from(document.querySelectorAll(selector)))
      .flat();

    if (!icons.length) return;

    this.createTooltip();
    this.createOutline();

    icons.forEach((icon) => {
      icon.addEventListener('mouseenter', this.handleMouseEnter);
    });

    const visual = document.querySelector('.hero__visual');
    const moveTarget = visual || document;
    moveTarget.addEventListener('mousemove', this.handleGlobalMouseMove);
  }

  initDelayedFadeInForHeroIcons() {
    const heroFadeInIcons = Array.from(document.querySelectorAll('.hero__icon'));

    if (!heroFadeInIcons.length) return;

    heroFadeInIcons.forEach((icon) => {
      icon.classList.add('FadeIn');
    });

    window.addEventListener('scroll', () => {
      heroFadeInIcons.forEach((icon) => {
        icon.classList.add('is-visible');
      });
    }, { once: true, passive: true });
  }

  initIconsResponsivePosition() {
    if (typeof document === 'undefined') return;

    const orbits = document.querySelector('.hero__visual-orbits');

    if (!orbits) return;

    const desktopWidth = 1376;
    let lastWidth = 0;
    let scheduled = false;

    const applyScale = (width) => {
      const safeWidth = Number.isFinite(width) ? width : desktopWidth;
      const scale = Math.min(safeWidth / desktopWidth, 1);
      orbits.style.setProperty('--hero-icon-scale', String(scale));
    };

    const scheduleUpdate = (width) => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (window.innerWidth <= 768) {
          orbits.style.removeProperty('--hero-icon-scale');
          return;
        }
        applyScale(width);
      });
    };

    const updateScaleFromObserver = (width) => {
      if (width === lastWidth) return;
      lastWidth = width;
      scheduleUpdate(width);
    };

    if (window.innerWidth <= 768) {
      orbits.style.removeProperty('--hero-icon-scale');
    } else {
      const initialWidth = orbits.getBoundingClientRect().width;
      lastWidth = initialWidth;
      applyScale(initialWidth);
    }

    if (typeof ResizeObserver !== 'undefined') {
      this.iconResizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const width = entry.contentRect ? entry.contentRect.width : entry.target.getBoundingClientRect().width;
          updateScaleFromObserver(width);
        }
      });
      this.iconResizeObserver.observe(orbits);
    } else {
      window.addEventListener('resize', () => {
        scheduleUpdate(orbits.getBoundingClientRect().width);
      }, { passive: true });
    }
  }

  createTooltip() {
    const tooltip = document.createElement('div');
    tooltip.className = 'hero-tooltip';

    const heroRoot = document.querySelector('.hero');
    const parent = heroRoot || document.body;

    parent.appendChild(tooltip);
    this.tooltipElement = tooltip;
  }

  createOutline() {
    const outline = document.createElement('div');
    outline.className = 'hero__icon-outline';

    const visual = document.querySelector('.hero__visual');
    const parent = visual || document.querySelector('.hero') || document.body;

    parent.appendChild(outline);
    this.outlineElement = outline;
  }

  handleMouseEnter = (event) => {
    if (!this.tooltipElement) return;

    const target = event.currentTarget;
    this.activeIcon = target;
    this.activeIconRect = target.getBoundingClientRect();

    this.updateOutlinePosition(target, this.activeIconRect);

    const defaultText = this.tooltipTexts.hero__globe;
    const iconClass = Array.from(target.classList).find(
      (cls) => this.tooltipTexts[cls],
    );
    const mapText = iconClass ? this.tooltipTexts[iconClass] : null;
    const customText = target.getAttribute('data-hero-tooltip');

    this.tooltipElement.textContent = customText || mapText || defaultText;
    this.tooltipElement.style.opacity = '1';

    this.updateTooltipPosition(event);
  };

  updateTooltipPosition(event) {
    if (!this.tooltipElement) return;

    const offset = 16;
    if (!this.tooltipParentRect) {
      const parent = this.tooltipElement.offsetParent || document.body;
      this.tooltipParentRect = parent.getBoundingClientRect();
    }
    const parentRect = this.tooltipParentRect;

    this.tooltipElement.style.left = `${event.clientX - parentRect.left + offset}px`;
    this.tooltipElement.style.top = `${event.clientY - parentRect.top + offset}px`;
  }

  handleGlobalMouseMove = (event) => {
    if (!this.activeIcon || !this.tooltipElement) return;

    this.updateTooltipPosition(event);

    const rect = this.activeIconRect || this.activeIcon.getBoundingClientRect();
    const tolerance = 10;
    const x = event.clientX;
    const y = event.clientY;

    const inside =
      x >= rect.left - tolerance &&
      x <= rect.right + tolerance &&
      y >= rect.top - tolerance &&
      y <= rect.bottom + tolerance;

    if (!inside) {
      this.activeIcon = null;
      this.activeIconRect = null;
      this.tooltipParentRect = null;

      if (this.outlineElement) {
        this.outlineElement.style.opacity = '0';
      }

      this.tooltipElement.style.opacity = '0';
    }
  };

  updateOutlinePosition(target, targetRect) {
    if (!this.outlineElement) return;

    if (!this.visualEl) {
      this.visualEl = document.querySelector('.hero__visual');
    }
    const visualRect = this.visualEl
      ? this.visualEl.getBoundingClientRect()
      : document.body.getBoundingClientRect();

    const rect = targetRect || target.getBoundingClientRect();

    const size = window.innerWidth >= 1280 ? 190 : window.innerWidth * 0.13;
    const centerX = rect.left + rect.width / 2 - visualRect.left;
    const centerY = rect.top + rect.height / 2 - visualRect.top;

    this.outlineElement.style.width = `${size}px`;
    this.outlineElement.style.height = `${size}px`;
    this.outlineElement.style.left = `${centerX - size / 2}px`;
    this.outlineElement.style.top = `${centerY - size / 2}px`;
    this.outlineElement.style.opacity = '1';
  }
}

new HeroIconsTooltip();

